export const Translations_AR = {
	footer: {
		join: "انضم إلى النقاش لآن. لا حاجة للتطبيق أو التسجيل.",
		climate: "نقاش صديق للبيئة.",
		tree: "زرعنا الشجرة.",
		start: "أنشئ سلسلة فيديو مجانًا.",
	},
};
